var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconRefresh3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.65 6.999C.65 3.25 3.554.2 7.123.2c1.629 0 3.186.638 4.383 1.796l.195.197.002-1.982h1.199V4.59H8.717v-1.2l2.436-.001c-.034-.044-.071-.088-.108-.131l-.207-.231C9.845 1.978 8.526 1.4 7.123 1.4c-2.907 0-5.272 2.512-5.272 5.599s2.365 5.6 5.272 5.6c2.223 0 4.218-1.493 4.966-3.715l.1-.317 1.15.336-.028.096c-.841 2.87-3.327 4.799-6.188 4.799-3.569 0-6.473-3.05-6.473-6.799z",
    transform: "translate(-119 -145) translate(0 100) translate(101 31) translate(18 12) translate(0 2) translate(1 1)"
  })));
}
export default SvgCommonIconRefresh3;